import { CourseGroupApi } from "api/coursegroups/coursegroupsApi";
import { IDropdownOption } from "components/atoms";
import { useCourseGroups } from "./useCourseGroups";

export interface CourseGroupOption extends IDropdownOption {
  group?: CourseGroupApi;
}
export const useCourseGroupsOptions = (addNewPlaceOption: boolean = false, categories?: number[]) => {
  const filter = categories ? `categories in (${categories.join(",")})` : undefined;
  const { isLoading, courseGroups } = useCourseGroups(0, 1_000_000, filter);

  const options: CourseGroupOption[] = (courseGroups ?? []).map((x) => ({
    value: x.id.toString(),
    label: x.name,
    group: x,
  }));

  if (addNewPlaceOption) options?.unshift({ value: "-1", label: "Dodaj nową grupę" });

  return { loading: isLoading, options };
};
